import { ReactNode } from 'react';
import Sidebar from './components/Sidebar';
import classes from './Layout.module.scss';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className={classes.root}>
      <aside className={classes.sidebar}>
        <Sidebar />
      </aside>
      <main className={classes.content}>{children}</main>
    </div>
  );
}
